
import React, { useContext } from 'react';

import { Breakpoint } from '@rta/rta-blueprint-library';

import { AppContext } from '@r-app/app-context';
import { RenderBreakpoint } from './render-breakpoint';
import { renderTracking } from '@r-services/render-tracking';

export type RenderBreakpointsPanelParams = {
	panelId: string;
};

export const RenderBreakpointsPanel = ({ panelId }: RenderBreakpointsPanelParams): React.ReactElement => {
	const { controller } = useContext(AppContext);
	const { kitchen } = controller;

	const jsxBreakpoints: Array<React.ReactElement> = [];
	const island = kitchen.design.islands.findByPanelId(panelId);
	const panel = island.panels.findById(panelId);
	const { height } = panel.size;

	// console.log('RenderBreakpoints:locator', locator);
	if (!controller.options.showBreakpoints) return null;

	// render panel breakpoints
	panel.breakpoints.children.forEach((breakpoint) => {
		jsxBreakpoints.push(<RenderBreakpoint
			key={breakpoint.id}
			{...{
				breakpoint: breakpoint as Breakpoint,
				center: { x: breakpoint.center, y: panel.center.y },
				height
			}}
		></RenderBreakpoint>);
	});

	renderTracking.incrementRender('RenderBreakpointsPanel');
	return <>{jsxBreakpoints}</>;
};
